<template>
  <b-form-input
    class="input-style text-right"
    autocomplete="off"
    v-model="_value"
    v-bind:class="_class"
    :size="size"
    :formatter="formatter"
    :placeholder="placeholder"
    :disabled="disabled"
  ></b-form-input>
</template>
<script>
import { unMaskMoney, convertPrice, parseDecimalNumber } from '@/utils/common';
export default {
  props: {
    value: {
      value: '',
      required: true,
    },
    allowDecimal: {
      type: Boolean,
      default: false,
    },
    size: {
      value: null,
      default: 'sm',
    },
    placeholder: {
      value: null,
      default: 'Vui lòng nhập',
    },
    inputClass: {
      value: null,
      default: '',
    },
    disabled: {
      value: null,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'valueChange',
  },
  computed: {
    _value: {
      get() {
        const v = this.value;
        if (v === null || v === undefined || v === '') {
          return null;
        }
        return this.formatter(v);
      },
      set(value) {
        if (value === '' || value === null || value === undefined) {
          this.$emit('valueChange', null);
          return;
        }
        const parsed = this.allowDecimal ? parseDecimalNumber(value) : Number(unMaskMoney(value));
        this.$emit('valueChange', Number.isFinite(parsed) ? parsed : null);
      },
    },
    _class: {
      get() {
        return this.inputClass;
      },
    },
  },
  methods: {
    formatter(value) {
      if (value === '' || value === null || value === undefined) return '';
      if (this.allowDecimal) {
        const n = parseDecimalNumber(value);
        if (!Number.isFinite(n)) return '';
        return convertPrice(n, 'vn-VN', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
      }
      return convertPrice(Number(unMaskMoney(value)));
    },
  },
};
</script>

<style scoped>
.input-style::-ms-clear {
  display: none;
}
.input-style::-webkit-search-cancel-button {
  display: none;
}
</style>
